import { Component } from '@angular/core';
import { ListConductivityprofiles } from 'src/app/models/conductivityprofiles.model';
import { ImportMaps } from 'src/app/models/importmaps.model';
import { Plant } from 'src/app/models/plant.model';
import { Train,TrainViewmodel } from 'src/app/models/train.model';
import { ConductivityprofilesService } from 'src/app/services/conductivityprofiles/conductivityprofiles.service';
import { ImportmapsService } from 'src/app/services/importmaps/importmaps.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { TrainService } from 'src/app/services/trains/trains.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { OpdataImport,ColMapping } from 'src/app/models/opdataCalc.model';
import { OpdataService } from 'src/app/services/opdata/opdata.service';
import { Opdata,RawOpdata } from 'src/app/models/opdata.model';

@Component({
  selector: 'app-import-opdata',
  templateUrl: './import-opdata.component.html',
  styleUrls: ['./import-opdata.component.scss']
})
export class ImportOpdataComponent {
  constructor(
    private router: Router,
    private toastr : ToastrService,
    private opdataService:OpdataService,  
    private trainService: TrainService,
    private plantService: PlantsService,
    private importmapsService: ImportmapsService,
  ) {}

  opdataImport:OpdataImport=new OpdataImport();
  colmaptemp:ColMapping=new ColMapping();

  rawColMap:ColMapping[]=[];

  dtoptions: DataTables.Settings = {};
  plants: Plant[] = [];
  trains: Train[] = [];
  opdata:RawOpdata[]=[];
  errorsList:string[]=[];
  ListConductivityprofiles: ListConductivityprofiles[] = [];
  SelectedId: string;
  plantDetails: Plant = new Plant();
  trainDetails: Train = new Train();
  
  importMaps: ImportMaps[] = [];
  showMaps = false;
  saveMap = false;

  showAlert=false;
  showImportDiv=true;

  fileName = ''; 
  mapname = '';
  fileSelected:File; 
  loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
  plantId: number;
  trainId:string;
  selectedTrain:Train=new Train();
  noOfStages:number = 0;
  syncOption:string='';
  selectedImportMap:ImportMaps = new ImportMaps();
  objImportMap:ImportMaps=new ImportMaps();
  paramBuilder:string = '';
  
  
  CurrentUserId = this.loggedInuserRole.userId;
  loggedInUserRole:string;
  loggedinUserId:string;
  plantAndUserId:string;

  dateCol:string='';
  timeCol:string='';
  phCol:string='';
  tempCol:string='';
  s1concflowCol:string='';
  s1permflowCol:string='';
  s1feedpressCol:string='';
  s1concpressCol:string='';
  s1permpressCol:string='';
  s1feedcondCol:string='';
  s1permcondCol:string='';
  s2concflowCol:string='';
  s2permflowCol:string='';
  s2feedpressCol:string='';
  s2concpressCol:string='';
  s2permpressCol:string='';
  s2feedcondCol:string='';
  s2permcondCol:string='';
  s3concflowCol:string='';
  s3permflowCol:string='';
  s3feedpressCol:string='';
  s3concpressCol:string='';
  s3permpressCol:string='';
  s3feedcondCol:string='';
  s3permcondCol:string='';
  UD1Col:string='';
  UD2Col:string='';
  UD3Col:string='';
  UD4Col:string='';
  UD5Col:string='';
  commentsCol:string='';
  referencePoint:number=0;
  //Below code added on 26th February 2025
  UserDefinedField1:string;
  UserDefinedField2:string;
  UserDefinedField3:string;
  UserDefinedField4:string;
  UserDefinedField5:string;
  showUserDefinedField1:boolean=false;
  showUserDefinedField2:boolean=false;
  showUserDefinedField3:boolean=false;
  showUserDefinedField4:boolean=false;
  showUserDefinedField5:boolean=false;
  showUserDefinedDiv:boolean=false;
  onFileSelected(event) {

    this.fileSelected = event.target.files[0];

    if (this.fileSelected) {

        this.fileName = this.fileSelected.name;

        
    }
}

importRawOpData() {
  this.opdataImport.AspNetUsersId=this.CurrentUserId;
  this.opdataImport.TrainId = this.trainId;

  if(this.syncOption == '1')
  {
  this.opdataImport.ImportOption="Alert";
  }
  else if(this.syncOption == '2')
  {
  this.opdataImport.ImportOption="ReplaceExisting";
  }
  else if(this.syncOption == '3')
  {
  this.opdataImport.ImportOption="DeleteExisting";
  }
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="Date";
  this.colmaptemp.value=this.dateCol;
  this.rawColMap.push(this.colmaptemp);
  
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="Time";
  this.colmaptemp.value=this.timeCol;
  this.rawColMap.push(this.colmaptemp);
  
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="ph";
  this.colmaptemp.value=this.phCol;
  this.rawColMap.push(this.colmaptemp);
  
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="temp";
  this.colmaptemp.value=this.tempCol;
  this.rawColMap.push(this.colmaptemp);
  
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s1_conc_flow";
  this.colmaptemp.value=this.s1concflowCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s1_perm_flow";
  this.colmaptemp.value=this.s1permflowCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s1_feed_press";
  this.colmaptemp.value=this.s1feedpressCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s1_conc_press";
  this.colmaptemp.value=this.s1concpressCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s1_perm_press";
  this.colmaptemp.value=this.s1permpressCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s1_feed_cond";
  this.colmaptemp.value=this.s1feedcondCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s1_perm_cond";
  this.colmaptemp.value=this.s1permcondCol;
  this.rawColMap.push(this.colmaptemp);
  
  if(this.noOfStages>=2)
  {
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s2_conc_flow";
  this.colmaptemp.value=this.s2concflowCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s2_perm_flow";
  this.colmaptemp.value=this.s2permflowCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s2_feed_press";
  this.colmaptemp.value=this.s2feedpressCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s2_conc_press";
  this.colmaptemp.value=this.s2concpressCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s2_perm_press";
  this.colmaptemp.value=this.s2permpressCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s2_feed_cond";
  this.colmaptemp.value=this.s2feedcondCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s2_perm_cond";
  this.colmaptemp.value=this.s2permcondCol;
  this.rawColMap.push(this.colmaptemp);
  }

  if(this.noOfStages==3)
  {
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s3_conc_flow";
  this.colmaptemp.value=this.s3concflowCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s3_perm_flow";
  this.colmaptemp.value=this.s3permflowCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s3_feed_press";
  this.colmaptemp.value=this.s3feedpressCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s3_conc_press";
  this.colmaptemp.value=this.s3concpressCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s3_perm_press";
  this.colmaptemp.value=this.s3permpressCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s3_feed_cond";
  this.colmaptemp.value=this.s3feedcondCol;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="s3_perm_cond";
  this.colmaptemp.value=this.s3permcondCol;
  this.rawColMap.push(this.colmaptemp);
  }

  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="ud1";
  this.colmaptemp.value=this.UD1Col;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="ud2";
  this.colmaptemp.value=this.UD2Col;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="ud3";
  this.colmaptemp.value=this.UD3Col;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="ud4";
  this.colmaptemp.value=this.UD4Col;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="ud5";
  this.colmaptemp.value=this.UD5Col;
  this.rawColMap.push(this.colmaptemp);
  this.colmaptemp=new ColMapping();
  this.colmaptemp.key="comments";
  this.colmaptemp.value=this.commentsCol;
  this.rawColMap.push(this.colmaptemp);
  
  

  this.opdataImport.ColumnMaps=this.rawColMap;

  if(this.saveMap)
  {
    if(this.mapname!='')
    {

    this.objImportMap.PlantId = parseInt(this.SelectedId);
    this.objImportMap.TrainId = parseInt(this.trainId);
    this.objImportMap.Name = this.mapname;
    if(this.syncOption!='0')
    {      
      this.paramBuilder = 'sync:' + this.syncOption + ';';
    }
    this.paramBuilder += 'sheet:' + this.opdataImport.Worksheet + ';';
    this.paramBuilder += 'headerow:' + this.opdataImport.HeaderRow + ';';
    this.paramBuilder += 'colMapping:';
    this.paramBuilder += 'DateCol{v}' + this.dateCol + ',';
    this.paramBuilder += 'TimeCol{v}' + this.timeCol + ',';
    this.paramBuilder += 'pHCol{v}'  + this.phCol + ',';
    this.paramBuilder += 'tempCol{v}' + this.tempCol + ',';
    this.paramBuilder += 's1concflowCol{v}' + this.s1concflowCol + ',';
    this.paramBuilder += 's1permflowCol{v}' + this.s1permflowCol + ',';
    this.paramBuilder += 's1feedpressCol{v}' + this.s1feedpressCol + ',';
    this.paramBuilder += 's1concpresseCol{v}' + this.s1concpressCol + ',';
    this.paramBuilder += 's1permpressCol{v}' + this.s1permpressCol + ',';
    this.paramBuilder += 's1feedcondCol{v}' + this.s1feedcondCol + ',';
    this.paramBuilder += 's1permcondCol{v}' + this.s1permcondCol + ',';
    if(this.noOfStages>=2)
    {
      this.paramBuilder += 's2concflowCol{v}' + this.s2concflowCol + ',';
      this.paramBuilder += 's2permflowCol{v}' + this.s2permflowCol + ',';
      this.paramBuilder += 's2feedpressCol{v}' + this.s2feedpressCol + ',';
      this.paramBuilder += 's2concpressCol{v}' +this.s2concpressCol + ',';
      this.paramBuilder += 's2permpressCol{v}' +this.s2permpressCol + ',';
      this.paramBuilder += 's2feedcondCol{v}' + this.s2feedcondCol + ',';
      this.paramBuilder += 's2permcondCol{v}' + this.s2permcondCol + ',';
    }
  
    if(this.noOfStages==3)
    {
      this.paramBuilder += 's3concflowCol{v}' + this.s3concflowCol + ',';
      this.paramBuilder += 's3permflowCol{v}' + this.s3permflowCol + ',';
      this.paramBuilder += 's3feedpressCol{v}' + this.s3feedpressCol + ','
      this.paramBuilder += 's3concpressCol{v}' + this.s3concpressCol + ',';
      this.paramBuilder += 's3permpressCol{v}' + this.s3permpressCol + ',';
      this.paramBuilder += 's3feedcondCol{v}' + this.s3feedcondCol + ',';
      this.paramBuilder += 's3permcondCol{v}' + this.s3permcondCol + ',';
    }
  
    this.paramBuilder += 'ud1Col{v}' + this.UD1Col + ',';
    this.paramBuilder += 'ud2Col{v}' + this.UD2Col + ',';
    this.paramBuilder += 'ud3Col{v}' + this.UD3Col + ',';
    this.paramBuilder += 'ud4Col{v}' + this.UD4Col + ',';
    this.paramBuilder += 'ud5Col{v}' + this.UD5Col + ',';
    this.paramBuilder += 'commentsCol{v}' + this.commentsCol + ';';

    this.objImportMap.Parameters=this.paramBuilder;
    this.opdataImport.importMap=this.objImportMap;
  }
}

  this.opdataService.importRawOpdata(this.opdataImport,this.fileSelected).subscribe({
    next: (model) => {
      if(model.ImportOption=='DeleteExisting' || model.ImportOption == 'ReplaceExisting')
      {
        this.showAlert=false;
          this.showImportDiv=true;
      this.toastr.success('Opdata Imported Successfully.', 'Information')
      // this.router.navigate(['/opdata'], {
      
    
      //   queryParams: {PlantId: btoa(this.plantId.toString()), trainId:  btoa(this.trainId.toString())},
       
      //   skipLocationChange: true,
      // });
        this.router.navigate(['/opdata'], {
          queryParams: {
            PlantId: btoa(this.plantId.toString()),
            trainId: btoa(this.trainId.toString())
          },
         // skipLocationChange: true,
        });
    }
    else if(model.ImportOption=='Alert')
    {
        if(model.importErrors=='')
        {
          this.showAlert=false;
          this.showImportDiv=true;
          this.toastr.success('Opdata and OpdataCalc Imported Successfully.', 'Information')
      // this.router.navigate(['/opdata'], {
      //   queryParams: {PlantId: this.plantId, trainId: this.trainId},
      //   skipLocationChange: true,
       
      // });

          this.router.navigate(['/opdata'], {
            queryParams: {
              PlantId: btoa(this.plantId.toString()),
              trainId: btoa(this.trainId.toString())
            },
            skipLocationChange: true,
          });

       //update reference point to train if it is null
       /* let trainobj = new TrainViewmodel();
       this.trainService.getTrainById(this.trainId).subscribe({
        next: (response) => {
          this.trainDetails = response;
          this.referencePoint = this.trainDetails.RefPoint;
          if(this.referencePoint==null)
          {
            this.opdataService.getRawOpdataFirstRowByTrainId(this.trainId).subscribe({
              next: (response) => {
              this.opdata = response;
              this.trainDetails.RefPoint=
              trainobj.traindata.RefPoint=this.trainDetails.RefPoint;
              }
            })
          }
        }
      });*/
        } 
        else
        {
          this.showAlert=true;
          this.showImportDiv=false;
          var splitErrs=model.importErrors.split(';');
    splitErrs.forEach(element => {
      if(element!='')
      {
      this.errorsList.push(element);
      }
    });
        }
    }
    },
  });
}

retrunToImport()
{
  window.location.reload();
 
  
}

retrunToManage(plantId, trainId){
  this.showAlert=false;
          this.showImportDiv=true;
         this.router.navigate(['/opdata'], {
        queryParams: {PlantId: btoa(plantId.toString()), trainId:  btoa(trainId.toString())},
        skipLocationChange: true,
      });
}
setImageMap(e:any){
  this.saveMap=e.currentTarget.checked;
}

setSyncOption(e:string)
{
  this.syncOption=e;
}

  getSelectedId(e) {
    this.showMaps=true;
    this.SelectedId = e.target.value;
    this.trainId=e.target.value;


    if(this.loggedInUserRole =='Standard User')
      {
    this.plantAndUserId = this.SelectedId + 'Z' + this.loggedinUserId;
    this.trainService.GetAccessibleTrainListByPlantId(this.plantAndUserId)
      
      .subscribe(
        (response: Train[]) => {
          this.trains = response;
        },
        (error: any) => {
          console.log('error list');
        }
      );
  }
  else
  {
    this.trainService.getTrainByPlantId(this.SelectedId).subscribe(
      (response: Train[]) => {
        this.trains = response;
      },

      (error: any) => {
        console.log('error list');
      }
    );
  }
    
    this.plantService.getPlant(this.SelectedId).subscribe({
      next: (response) => {
        this.plantDetails = response;
        this.plantId=this.plantDetails.Id;
        console.log(this.plantDetails);
      },
    });

  }

  mapImportFields(e)
  {
      this.importmapsService.getImportMapById(e.target.value).subscribe(
        (response: ImportMaps) => {
          this.selectedImportMap = response;
          if(this.selectedImportMap!=null)
          {
            this.populateMappedFields(this.selectedImportMap.Parameters);
          }
        },
  
        (error: any) => {
          console.log('error list');
        }
      );
  }
 
  populateMappedFields(parameter:string)
  {
    if(parameter!='')
    {
    var splitMaps=parameter.split(';');
    splitMaps.forEach(element => {
      var keyValMaps=element.split(':');
      if(keyValMaps.length==2)
      {
        if(keyValMaps[0]=='sync')
        {
          this.syncOption =  keyValMaps[1];
        }
        else if(keyValMaps[0]=='sheet')
        {
          this.opdataImport.Worksheet = parseInt(keyValMaps[1]);
        }
        else if(keyValMaps[0]=='headerow')
        {
          this.opdataImport.HeaderRow = parseInt(keyValMaps[1]);
        }
        else if(keyValMaps[0]=='colMapping')
        {
          var colmap=keyValMaps[1].split(",");
          if(colmap.length>0)
          {
colmap.forEach(cols => {
  var colValMaps=cols.split("{v}");
  if(colValMaps.length==2)
  {
    if(colValMaps[0]=='DateCol')
    {
      this.dateCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='TimeCol')
    {
      this.timeCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='pHCol')
    {
      this.phCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='tempCol')
    {
      this.tempCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s1concflowCol')
    {
      this.s1concflowCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s1permflowCol')
    {
      this.s1permflowCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s1feedpressCol')
    {
      this.s1feedpressCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s1concpresseCol')
    {
      this.s1concpressCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s1permpressCol')
    {
      this.s1permpressCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s1feedcondCol')
    {
      this.s1feedcondCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s1permcondCol')
    {
      this.s1permcondCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s2concflowCol')
    {
      this.s2concflowCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s2permflowCol')
    {
      this.s2permflowCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s2feedpressCol')
    {
      this.s2feedpressCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s2concpressCol')
    {
      this.s2concpressCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s2permpressCol')
    {
      this.s2permpressCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s2feedcondCol')
    {
      this.s2feedcondCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s2permcondCol')
    {
      this.s2permcondCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s3concflowCol')
    {
      this.s3concflowCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s3permflowCol')
    {
      this.s3permflowCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s3feedpressCol')
    {
      this.s3feedpressCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s3concpressCol')
    {
      this.s3concpressCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s3permpressCol')
    {
      this.s3permpressCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s3feedcondCol')
    {
      this.s3feedcondCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='s3permcondCol')
    {
      this.s3permcondCol =  colValMaps[1];
    }
    else if(colValMaps[0]=='ud1Col')
    {
      this.UD1Col =  colValMaps[1];
    }
    else if(colValMaps[0]=='ud2Col')
    {
      this.UD2Col =  colValMaps[1];
    }
    else if(colValMaps[0]=='ud3Col')
    {
      this.UD3Col =  colValMaps[1];
    }
    else if(colValMaps[0]=='ud4Col')
    {
      this.UD4Col =  colValMaps[1];
    }
    else if(colValMaps[0]=='ud5Col')
    {
      this.UD5Col =  colValMaps[1];
    }
    else if(colValMaps[0]=='commentsCol')
    {
      this.commentsCol =  colValMaps[1];
    }
  }
});
          }          
        }
      }
    });
  }
  }

  getSelectedTrainId(e){
    this.showMaps = false;
    this.trainId = e.target.value;
    
    this.trainService.getTrainById(this.trainId).subscribe(
      (response: Train) => {
        this.selectedTrain = response;
        this.noOfStages=this.selectedTrain.Stages;
        //Below code added on 26th February 2025
        this.noOfStages=this.selectedTrain.Stages;
        this.UserDefinedField1 = this.selectedTrain.Ud1;
        this.UserDefinedField2 = this.selectedTrain.Ud2;
        this.UserDefinedField3 = this.selectedTrain.Ud3;
        this.UserDefinedField4 = this.selectedTrain.Ud4;
        this.UserDefinedField5 = this.selectedTrain.Ud5;
        //added on 26th February 2025
        this.checkUserDefinedField();
        this.IsUserDefinedDivVisible();

      },

      (error: any) => {
        console.log('error list');
      }
    );

    this.importmapsService.getImportmapByTrainId(this.SelectedId,this.trainId).subscribe(
      (response: ImportMaps[]) => {
        this.importMaps = response;
        if(this.importMaps.length>0)
        {
          this.showMaps=true;
        }
        console.log(this.importMaps);
      },
      (error: any) => {
        console.log('error list');
      }
    );

    
  }
//Below function added on 26th February 2025
IsUserDefinedDivVisible()
{
  if(this.UserDefinedField1 !='' ||this.UserDefinedField2 !='' || this.UserDefinedField3 !='' ||this.UserDefinedField4!=''||this.UserDefinedField5!='')
  {
    this.showUserDefinedDiv=true;
  }
  else{
    this.showUserDefinedDiv=false;
  }

}
  checkUserDefinedField() {
    if (this.UserDefinedField1 === "") {
      this.showUserDefinedField1 = false;

    }
    else {
      this.showUserDefinedField1 = true;
    }
    if (this.UserDefinedField2 === "") {
      this.showUserDefinedField2 = false;

    }
    else {
      this.showUserDefinedField2 = true;
    }
    if (this.UserDefinedField3 === "") {
      this.showUserDefinedField3 = false;

    }
    else {
      this.showUserDefinedField3 = true;
    }
    if (this.UserDefinedField4 === "") {
      this.showUserDefinedField4 = false;

    }
    else {
      this.showUserDefinedField4 = true;
    }
    if (this.UserDefinedField5 === "") {
      this.showUserDefinedField5 = false;

    }
    else {
      this.showUserDefinedField5 = true;
    }
  }
  ngOnInit(): void {
    this.dtoptions = {
      pagingType: 'full_numbers',
      order: [[0, 'desc']],
    };

    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.loggedInUserRole = loggedInuserRole.role;
      this.loggedinUserId = loggedInuserRole.userId;
      this.plantService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
        },
      })
      
    }
    else
    {
    this.plantService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
      },
      error: (response) => {
        console.log(response);
      },
    });
  }

    // get plantId from breadcrumbs
    this.plantService.selectedPlant$
      .subscribe(plantId => {
        if (plantId) {
          this.getSelectedId({ target: { value: plantId } });
        }
      });

    // get trainid from breadcrumbs
    this.plantService.selectedTrain$
      .subscribe(trainId => {
        if (trainId) {
          this.getSelectedTrainId({ target: { value: trainId } });
        }
      });
}
}
